import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { GenericSearchSelectModule } from '../../generic-search-select';
import { CancelRandomTestDialogComponent } from './cancel-random-test-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    GenericSearchSelectModule
  ],
  declarations: [CancelRandomTestDialogComponent],
  exports: [CancelRandomTestDialogComponent]
})
export class CancelRandomTestDialogModule {}
